function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M512,147.484c0-16.505-13.427-29.932-29.932-29.932c-4.893,0-8.859,3.966-8.859,8.859c0,4.892,3.965,8.859,8.859,8.859 c6.735,0,12.215,5.481,12.215,12.215s-5.48,12.215-12.215,12.215h-1.912c-0.002,0-0.003,0-0.006,0H150.746l5.91-59.963 c0.246-2.489-0.572-4.966-2.251-6.818c-1.68-1.853-4.063-2.91-6.565-2.91h-27.521c4.165-17.854,23.049-31.58,41.765-35.357 c4.795-0.969,7.898-5.64,6.93-10.437c-0.967-4.795-5.63-7.899-10.437-6.931c-8.633,1.742-16.305,4.634-23.013,8.333l-0.539-2.745 c-0.943-4.8-5.586-7.93-10.399-6.989c-4.8,0.941-7.93,5.596-6.989,10.398l2.173,11.086c-3.582,3.562-6.65,7.395-9.177,11.385 c-9.142-14.442-25.26-26.889-47.939-31.467c-4.794-0.967-9.47,2.135-10.437,6.931c-0.967,4.795,2.135,9.468,6.93,10.437 c4.921,0.993,9.851,2.68,14.524,4.942c-3.652,2.787-4.596,7.96-2.043,11.87c1.698,2.604,4.534,4.019,7.427,4.019 c1.659,0,3.338-0.467,4.832-1.44l5.456-3.559c5.658,5.541,9.857,12.181,11.569,19.523H75.204c-2.5,0-4.885,1.057-6.565,2.91 c-1.68,1.853-2.497,4.329-2.251,6.818l5.91,59.963H29.931c-6.735,0-12.215-5.481-12.215-12.215s5.481-12.215,12.215-12.215 c4.893,0,8.859-3.966,8.859-8.859c0-4.892-3.965-8.859-8.859-8.859C13.427,117.55,0,130.979,0,147.484 s13.427,29.932,29.932,29.932h1.918c15.315,17.2,19.698,41.608,11.066,63.185l-18.851,47.128 c-16.549,41.375-10.304,87.715,15.408,122.943H24.693c-4.893,0-8.859,3.966-8.859,8.859v47.895c0,4.892,3.965,8.859,8.859,8.859 h389.446c4.893,0,8.859-3.966,8.859-8.859s-3.965-8.859-8.859-8.859H33.552v-30.178h448.726v30.178h-38.61 c-4.893,0-8.859,3.966-8.859,8.859s3.965,8.859,8.859,8.859h47.469c4.893,0,8.859-3.966,8.859-8.859v-47.895 c0-4.892-3.965-8.859-8.859-8.859h-14.78c25.713-35.228,31.958-81.567,15.407-122.943l-18.851-47.128 c-8.644-21.608-4.236-46.054,11.131-63.258C499.63,176.322,512,163.323,512,147.484z M138.066,107.726l-5.124,51.973h-42.84 l-5.124-51.973H138.066z M62.434,410.672c-29.238-31.194-37.879-76.459-21.917-116.362l18.851-47.128 c9.287-23.218,6.894-48.977-5.61-69.765h32.248c11.27,17.494,14.363,42.065,7.783,63.921l-14.191,47.128 c-12.371,41.087-7.512,87.24,12.042,122.207H62.434z M194.969,242.971l-4.936,47.128c-4.26,40.684-2.427,86.52,4.573,120.576 h-30.502v-0.002c-14.17-31.977-18.177-77.517-10.112-117.918l4.06-20.332c0.959-4.798-2.154-9.463-6.952-10.421 c-4.804-0.954-9.464,2.156-10.421,6.953l-4.06,20.332c-8.155,40.843-4.794,86.814,8.347,121.387h-32.487 C90.749,379.17,84.461,333.756,96.56,293.575l14.191-47.128c6.904-22.932,4.968-48.48-4.597-69.029h34.818h0.267 c7.157,17.814,9.127,43.011,4.79,64.742c-0.959,4.798,2.154,9.463,6.953,10.421c0.585,0.117,1.168,0.172,1.743,0.172 c4.138,0,7.837-2.914,8.678-7.126c4.525-22.669,3.139-48.005-3.331-68.21h32.594C196.366,195.898,197.297,220.74,194.969,242.971z M247.141,410.672h-34.423c-7.297-32.573-9.31-78.21-5.067-118.729l4.936-47.128c2.355-22.484,1.564-47.633-1.911-67.398h36.465 V410.672z M303.113,410.672h-38.255V177.417h40.296c-3.474,19.765-4.266,44.915-1.91,67.398l4.936,47.128 C312.424,332.463,310.411,378.1,303.113,410.672z M351.726,410.672h-30.501c7.001-34.056,8.834-79.891,4.573-120.576 l-4.936-47.128c-2.328-22.23-1.398-47.072,2.302-65.553h32.595c-6.47,20.205-7.856,45.541-3.33,68.211l9.409,47.128 C369.904,333.155,365.899,378.695,351.726,410.672z M475.314,294.309c15.962,39.904,7.322,85.169-21.916,116.362h-29.195 c8.307-14.836,14.076-31.867,16.89-50.087c0.748-4.834-2.568-9.361-7.402-10.107c-4.849-0.749-9.362,2.569-10.108,7.402 c-3.069,19.863-10.042,38.012-20.231,52.792h-32.487c13.141-34.573,16.502-80.544,8.348-121.387l-9.409-47.128 c-4.338-21.732-2.367-46.929,4.79-64.742h35.083c-9.565,20.549-11.501,46.098-4.597,69.029l14.19,47.128 c3.644,12.1,5.66,24.836,5.993,37.856c0.123,4.814,4.063,8.633,8.85,8.633c0.077,0,0.154-0.001,0.23-0.002 c4.891-0.125,8.755-4.191,8.631-9.082c-0.373-14.598-2.641-28.901-6.74-42.512l-14.19-47.128 c-6.58-21.856-3.489-46.428,7.781-63.922h32.247c-12.506,20.788-14.899,46.548-5.612,69.765L475.314,294.309z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      "enableBackground": "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/facade.5ea5a503.svg";
export { SvgComponent as ReactComponent };